import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/GameModel";
import {GameLogic} from "../../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";
import { PlayerTypeConstants } from "../../../Constants/PlayerTypeConstants";

export interface IIntroScreenControllerOptions {
}

export class CharSelectController extends AnimationBaseController {
    $model: GameModel;
    char_number: number = 0;

    public constructor(@Inject private _options: IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("CharSelectController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                R_Button: {
                    instanceName: "btn_arrow_r",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.changeChar(true);
                        }
                    }
                },
                L_Button: {
                    instanceName: "btn_arrow_l",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.changeChar(false);
                        }
                    }
                },

            },
            modelWatch: {}
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(0);
    }

    changeChar(revert: boolean){
        const list = [
            PlayerTypeConstants.Kid,
            PlayerTypeConstants.Woman,
            PlayerTypeConstants.Man,
            PlayerTypeConstants.Oldman
        ];
        if(revert){
            this.char_number++;
        }else{
            this.char_number--;
        }

        if(this.char_number > 3){
            this.char_number = 0;
        }
        if(this.char_number < 0){
            this.char_number = 3;
        }

        this._gameLogic.setPlayerAType(list[this.char_number]);

        this.gotoAndStop(this.char_number);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

